import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthSessionService } from '../services/auth-session.service';

export const adminGuard: CanActivateFn = () => {

  const router = inject(Router);

  const authService =
    inject(AuthSessionService);

  if (authService.isTokenValid() && authService.isAdmin()) {

    return true;
  }

  router.navigate(['/home']);

  return false;
};
